import { createReducer, on } from '@ngrx/store';

import { DataVisualizationPopupState } from '@core/models/data-visualization/data-visualization.model';

import * as DataVisualizationActions from './data-visualization-popup.actions';

export const initialDataVisualizationPopupState: DataVisualizationPopupState = {
  isOpen: false,
  isPopup: false,
  isFilteringEnabled: false,
  activeVisualizationModules: {
    map: false,
    timeline: false,
    list: false,
    calendar: false,
    packing: false,
    warehouse: false,
    occupation: false
  }
};

export const dataVisualizationPopupReducer = createReducer(
  initialDataVisualizationPopupState,

  on(DataVisualizationActions.openPopup, (state) => ({
    ...state,
    isOpen: true
  })),

  on(DataVisualizationActions.closePopup, (state) => ({
    ...state,
    isOpen: false
  })),

  on(DataVisualizationActions.markAsPopup, (state) => ({
    ...state,
    isPopup: true
  })),

  on(
    DataVisualizationActions.setActiveVisualizationModules,
    (state, { map, calendar, timeline, list, packing, warehouse, occupation }) => ({
      ...state,
      activeVisualizationModules: {
        map,
        calendar,
        timeline,
        list,
        packing,
        warehouse,
        occupation
      }
    })
  ),

  on(DataVisualizationActions.setFilteringState, (state, { isFilteringEnabled }) => ({
    ...state,
    isFilteringEnabled
  }))
);
